export const GROUP_TYPE_DEFAULT = "DEFAULT";
export const GROUP_TYPE_LIKERT = "LIKERT";
